import FoldedHands from '@/shared/components/icons/FoldedHands.vue';
import FoldersOutline from '@/shared/components/icons/FoldersOutline.vue';
import MessageCircle from '@/shared/components/icons/MessageCircle.vue';
import AudioSquare from '@/shared/components/icons/AudioSquare.vue';
import VideoCameraRound from '@/shared/components/icons/VideoCameraRound.vue';
import type { NavItem } from '@/modules/admin/stores/admin-nav';

export const navItems: NavItem[] = [
  {
    title: 'Reading Plans',
    icon: FoldedHands,
    routeName: 'adminReadingPlans',
  },
  {
    title: 'Categories',
    icon: FoldersOutline,
    routeName: 'readingPlanCategories',
  },
  {
    title: 'Feedbacks',
    icon: MessageCircle,
    routeName: 'readingPlanFeedbacks',
  },
  {
    title: 'Video backgrounds',
    icon: VideoCameraRound,
    routeName: 'readingPlanVideos',
  },
  {
    title: 'Audio backgrounds',
    icon: AudioSquare,
    routeName: 'readingPlanAudio',
  },
];
